import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Input } from '../ui/input';
import { toast } from 'sonner';
import { BACKEND_URL, adminPut, reportError, AGENCY_ID } from './adminApi';
import { AdminSmtpCard } from './AdminSmtpCard';
import { AdminDolibarrAgencyCard } from './AdminDolibarrAgencyCard';
import { AdminGoogleReviewsCard } from './AdminGoogleReviewsCard';
import { AdminNewsCard } from './AdminNewsCard';
import { AdminFacebookCard } from './AdminFacebookCard';

export function AdminSettingsTab({ adminKey }) {
  const [facebookUrl, setFacebookUrl] = useState('');
  const [notifEmail, setNotifEmail] = useState('');
  const [music, setMusic] = useState({ url: '', name: '' });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [agency, musicRes] = await Promise.all([
          axios.get(`${BACKEND_URL}/api/agency-settings/${AGENCY_ID}`),
          axios.get(`${BACKEND_URL}/api/site-settings/music`),
        ]);
        if (cancelled) return;
        setFacebookUrl(agency.data.facebook_url || '');
        setNotifEmail(agency.data.notification_email || '');
        setMusic({ url: musicRes.data.music_url || '', name: musicRes.data.music_name || '' });
      } catch (err) {
        reportError('paramètres agence', err, () => toast.error('Impossible de charger les paramètres'));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const saveFacebook = async () => {
    try {
      await adminPut(`/api/admin/agency-settings/${AGENCY_ID}`, adminKey, { facebook_url: facebookUrl });
      toast.success('URL Facebook enregistrée');
    } catch (err) {
      reportError('URL Facebook', err, () => toast.error("Erreur lors de l'enregistrement"));
    }
  };

  const saveNotifEmail = async () => {
    try {
      await adminPut(`/api/admin/agency-settings/${AGENCY_ID}`, adminKey, { notification_email: notifEmail });
      toast.success('Email de notification enregistré');
    } catch (err) {
      reportError('email de notification', err, () => toast.error("Erreur lors de l'enregistrement"));
    }
  };

  const saveMusic = async () => {
    try {
      await adminPut('/api/admin/site-settings/music', adminKey, { music_url: music.url, music_name: music.name });
      toast.success('Musique de fond mise à jour');
    } catch (err) {
      reportError('musique', err, () => toast.error("Erreur lors de l'enregistrement"));
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-settings-tab">
      <Card className="p-5">
        <h3 className="font-['Space_Grotesk'] font-semibold mb-4">URL Facebook de l'agence</h3>
        <div className="flex gap-2 max-w-xl">
          <Input className="h-9" value={facebookUrl} onChange={(e) => setFacebookUrl(e.target.value)} placeholder="https://facebook.com/..." data-testid="facebook-url-input" />
          <Button size="sm" className="h-9 flex-shrink-0" onClick={saveFacebook}>OK</Button>
        </div>
      </Card>

      <Card className="p-5">
        <h3 className="font-['Space_Grotesk'] font-semibold mb-2">Notifications par email</h3>
        <p className="text-xs text-muted-foreground mb-4">L'agence reçoit ses notifications (devis, RDV, contacts, avis, candidatures) à l'adresse configurée. À défaut, l'adresse du compte SMTP est utilisée.</p>
        <div className="flex gap-2 max-w-xl">
          <Input className="h-9" value={notifEmail} onChange={(e) => setNotifEmail(e.target.value)} placeholder="contact@artois.ptitservices.com" data-testid="notif-email-input" />
          <Button size="sm" className="h-9 flex-shrink-0" onClick={saveNotifEmail}>OK</Button>
        </div>
      </Card>

      <AdminSmtpCard adminKey={adminKey} notificationEmail={notifEmail} />
      <AdminDolibarrAgencyCard adminKey={adminKey} />
      <AdminGoogleReviewsCard adminKey={adminKey} />
      <AdminFacebookCard adminKey={adminKey} />

      <Card className="p-5">
        <h3 className="font-['Space_Grotesk'] font-semibold mb-4">Musique de fond du site</h3>
        <p className="text-xs text-muted-foreground mb-3">Collez l'URL d'un fichier MP3 accessible en ligne. La musique sera jouée en boucle quand le visiteur active le bouton son.</p>
        <div className="space-y-3">
          <div>
            <label className="text-xs font-medium block mb-1">Nom de la musique</label>
            <Input className="h-9" value={music.name} onChange={(e) => setMusic((p) => ({ ...p, name: e.target.value }))} placeholder="Ex: Ambiance pop moderne" />
          </div>
          <div>
            <label className="text-xs font-medium block mb-1">URL du fichier MP3</label>
            <Input className="h-9" value={music.url} onChange={(e) => setMusic((p) => ({ ...p, url: e.target.value }))} placeholder="https://...fichier.mp3" />
          </div>
          <Button size="sm" onClick={saveMusic}>Enregistrer la musique</Button>
        </div>
      </Card>

      <AdminNewsCard adminKey={adminKey} />
    </div>
  );
}
